import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
 FaReceipt, FaUniversity, FaChevronLeft, FaChevronDown, FaCog, FaFile, FaSignOutAlt, FaChartBar, FaMoneyBillWave, FaLock, FaShareAlt
} from "react-icons/fa";
import { Divider } from "@mui/material";
import "./Sidebar.css";
import logo from "../Assets/BooksCompl1.png";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const [accountDropdown, setAccountDropdown] = useState(false);
  const [user, setUser] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRef = useRef(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error("Failed to fetch user data.");

        const data = await response.json();
        setUser(data.user);
      } catch (error) {
        console.error("User fetch error:", error);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen, setSidebarOpen]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const toggleDropdown = () => {
    setAccountDropdown((prev) => !prev);
  };

  const isActive = (path) => location.pathname === path;

  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  };

  return (
    <aside className={`sidebar ${sidebarOpen ? "open" : ""}`} ref={sidebarRef}>
      <div className="sidebar-top">
        <button className="close-btn" onClick={() => setSidebarOpen(false)}>
          <FaChevronLeft />
        </button>
        <div className="logo">
          <img src={logo} alt="Logo" className="img-fluid" />
        </div>
      </div>

      <div className="sidebar-bottom">
        <ul className="nav-links">

           <li className={isActive("/help") ? "active" : ""}>
            <Link to="/help" onClick={handleLinkClick}>
              <FaMoneyBillWave /> Help Guide
            </Link>
          </li>

          <li className={`dropdown ${accountDropdown ? "active" : ""}`} onClick={toggleDropdown}>
            <div className="dropdown-title">
              <FaCog /> Account Settings <FaChevronDown />
            </div>
            {accountDropdown && (
              <ul className="dropdown-menu">
                <li className={isActive("/profile") ? "active" : ""}>
                  <Link to="/profile" onClick={handleLinkClick}>My Profile</Link>
                </li>
                <li className={isActive("/invoice") ? "active" : ""}>
                  <Link to="/invoice" onClick={handleLinkClick}>Invoice Download</Link>
                </li>
                <li className={isActive("/payment-history") ? "active" : ""}>
                  <Link to="/payment-history" onClick={handleLinkClick}>Payment History</Link>
                </li>
              </ul>
            )}
          </li>

          <li className={isActive("/documents") ? "active" : ""}>
            <Link to="/documents" onClick={handleLinkClick}>
              <FaFile /> Documents
            </Link>
          </li>

          <li className={isActive("/pricing") ? "active" : ""}>
            <Link to="/pricing" onClick={handleLinkClick}>
              <FaMoneyBillWave /> Pricing Plan
            </Link>
          </li>
        </ul>

        <Divider sx={{ bgcolor: "white", my: 1 }} />
        <div className="section-title">Services</div>
        <ul className="nav-links">
          <li className={isActive("/tax-filing") ? "active" : ""}>
            {user?.isTaxFilingEnabled ? (
              <Link to="/tax-filing" onClick={handleLinkClick}>
                <FaReceipt /> Tax Filing
              </Link>
            ) : (
              <span className="disabled">
                <FaLock /> Tax Filing
              </span>
            )}
          </li>

          <li className={isActive("/bookkeeping") ? "active" : ""}>
            {user?.isBookkeepingEnabled ? (
              <Link to="/bookkeeping" onClick={handleLinkClick}>
                <FaUniversity /> Bookkeeping
              </Link>
            ) : (
              <span className="disabled">
                <FaLock /> Bookkeeping
              </span>
            )}
          </li>

          {user?.isUSAEnabled ? (
            <li className={isActive("/usa") ? "active" : ""}>
              <Link to="/usa" onClick={handleLinkClick}>
                <FaChartBar /> USA Company
              </Link>
            </li>
          ) : (
            <li className="disabled">
              <span>
                <FaLock /> USA Company
              </span>
            </li>
          )}

          <li className={isActive("/cfo") ? "active" : ""}>
            {user?.isCFOEnabled ? (
              <Link to="/cfo" onClick={handleLinkClick}>
                <FaFile /> CFO Advisory
              </Link>
            ) : (
              <span className="disabled">
                <FaLock /> CFO Advisory
              </span>
            )}
          </li>

          <li className={isActive("/registered-agent") ? "active" : ""}>
            {user?.isRegisteredAgentEnabled ? (
              <Link to="/registered-agent" onClick={handleLinkClick}>
                <FaFile /> Registered Agent
              </Link>
            ) : (
              <span className="disabled">
                <FaLock /> Registered Agent
              </span>
            )}
          </li>

          <li className={isActive("/annual-report") ? "active" : ""}>
            {user?.isAnnualReportServiceEnabled ? (
              <Link to="/annual-report" onClick={handleLinkClick}>
                <FaFile /> Annual Report Service
              </Link>
            ) : (
              <span className="disabled">
                <FaLock /> Annual Report Service
              </span>
            )}
          </li>
        </ul>
      </div>
        <div className="mobile-logout-container">
          <button className="mobile-logout-btn" onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </button>
        </div>
    </aside>
  );
};
export default Sidebar;